import styled from '@emotion/styled';
import { useEventLogging } from '@innovamat/event-logging';
import {
  authAxiosInstance,
  ManipulativeZone,
  useAppletInfo,
  useEnvVariables,
  useRegionParameters,
  useUser,
} from '@innovamat/ga-features';

const Wrapper = styled.div`
  width: 100%;
  height: calc(var(--vh, 1vh) * 100);
`;

export function ManipulativeEnvironment(): JSX.Element {
  const { regionParameters } = useRegionParameters({});
  const { user } = useUser();
  const { APOLLO_SERVER } = useEnvVariables();
  const { setEventData } = useEventLogging();

  const appletInfo = useAppletInfo();

  if (!regionParameters?.currency) return <></>;

  return (
    <Wrapper>
      <ManipulativeZone
        apolloServer={APOLLO_SERVER}
        axiosInstance={authAxiosInstance}
        language={user?.locale || ''}
        setEventData={setEventData}
        appletInfo={appletInfo}
        school={user?.organizationId || ''}
        uid={user?.id || ''}
      />
    </Wrapper>
  );
}
